export default {
	namespaced: true,
	state: () => ({
		useAdPool: false,
		bidsPerSecond: 0,
	}),
	getters: {
		resultUseAdpool: (state) => state.useAdPool,
		resultBidsPerSecond: (state) => state.bidsPerSecond,
	},
	mutations: {
		SET_DEFAULT_USE_ADPOOL(state) {
			state.useAdPool = false;
		},
		SET_DEFAULT_BIDS_PER_SECOND(state) {
			state.bidsPerSecond = 0;
		},
		UPDATE_USE_ADPOOL(state, payload) {
			state.useAdPool = payload;
		},
		UPDATE_BIDS_PER_SECOND(state, payload) {
			state.bidsPerSecond = payload;
		},
	},
};
